// extracted by mini-css-extract-plugin
module.exports = {"main":"List_main__3zQk6","btn2":"List_btn2__2S1T1"};